/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamGoldenRecordsRequestDto
 */
export interface StreamGoldenRecordsRequestDto {
    /**
     * Client name stored on the golden record
     * @type {string}
     * @memberof StreamGoldenRecordsRequestDto
     */
    clientName: string;
    /**
     * Start date in calendar format YYYY/MM/DD
     * @type {string}
     * @memberof StreamGoldenRecordsRequestDto
     */
    fromDate: string;
    /**
     * End date in calendar format YYYY/MM/DD
     * @type {string}
     * @memberof StreamGoldenRecordsRequestDto
     */
    toDate: string;
    /**
     * Maximum number of golden records to publish per batch
     * @type {number}
     * @memberof StreamGoldenRecordsRequestDto
     */
    batchSize: number;
    /**
     * Filter by treated flag. Defaults to false when omitted.
     * @type {boolean}
     * @memberof StreamGoldenRecordsRequestDto
     */
    treated?: boolean;
}

/**
 * Check if a given object implements the StreamGoldenRecordsRequestDto interface.
 */
export function instanceOfStreamGoldenRecordsRequestDto(value: object): value is StreamGoldenRecordsRequestDto {
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    if (!('batchSize' in value) || value['batchSize'] === undefined) return false;
    return true;
}

export function StreamGoldenRecordsRequestDtoFromJSON(json: any): StreamGoldenRecordsRequestDto {
    return StreamGoldenRecordsRequestDtoFromJSONTyped(json, false);
}

export function StreamGoldenRecordsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamGoldenRecordsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'clientName': json['clientName'],
        'fromDate': json['fromDate'],
        'toDate': json['toDate'],
        'batchSize': json['batchSize'],
        'treated': json['treated'] == null ? undefined : json['treated'],
    };
}

export function StreamGoldenRecordsRequestDtoToJSON(json: any): StreamGoldenRecordsRequestDto {
    return StreamGoldenRecordsRequestDtoToJSONTyped(json, false);
}

export function StreamGoldenRecordsRequestDtoToJSONTyped(value?: StreamGoldenRecordsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientName': value['clientName'],
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
        'batchSize': value['batchSize'],
        'treated': value['treated'],
    };
}

